import { Text } from "@astryxdesign/core/Text";
import { normalizeBackgroundImageUrl } from "@/lib/landing/media/background-image";
import { LandingCmsImage } from "@/components/landing/landing-cms-image";

export type LandingDeviceMockupProps = {
  imageUrlLight?: string;
  imageUrlDark?: string;
  alt?: string;
};

/**
 * MacBook Pro — вёрстка по devices.css (picturepan2, MIT).
 * Тёмный bezel, скриншот вплотную, серебристая база снизу. Без белых прослоек.
 * Скриншоты: светлая / тёмная тема лендинга.
 */
export function LandingDeviceMockup({
  imageUrlLight = "",
  imageUrlDark = "",
  alt = "Скриншот отчёта",
}: LandingDeviceMockupProps) {
  const light = normalizeBackgroundImageUrl(imageUrlLight);
  const dark = normalizeBackgroundImageUrl(imageUrlDark) || light;
  const hasShot = Boolean(light);
  const hasSeparateDark = Boolean(dark) && dark !== light;

  return (
    <div className="landing-device-mockup mx-auto w-full max-w-[740px]">
      <div className="landing-macbook">
        <div className="landing-macbook__frame">
          <div className="landing-macbook__screen">
            {hasShot ? (
              <>
                <LandingCmsImage
                  src={light}
                  alt={alt}
                  width={1280}
                  height={800}
                  fill
                  sizes="(max-width: 740px) 100vw, 740px"
                  priority
                  className="landing-device-mockup__shot landing-device-mockup__shot--light object-cover object-top"
                />
                {hasSeparateDark ? (
                  <LandingCmsImage
                    src={dark}
                    alt={alt}
                    width={1280}
                    height={800}
                    fill
                    sizes="(max-width: 740px) 100vw, 740px"
                    priority
                    className="landing-device-mockup__shot landing-device-mockup__shot--dark object-cover object-top"
                  />
                ) : null}
              </>
            ) : (
              <div className="flex h-full items-center justify-center px-4">
                <Text
                  color="secondary"
                  size="sm"
                  className="text-center leading-snug text-white/60"
                >
                  Скриншот
                </Text>
              </div>
            )}
          </div>
        </div>
        <div className="landing-macbook__base" aria-hidden />
      </div>
    </div>
  );
}
